import React from 'react';
import SectionMessage from '@atlaskit/section-message';

/**
 * @description
 * Compares two objects according to their keys,
 * and returns true if the data is different.
 * If the data is the same, it returns false.
 *
 * @example
 * Namespace.comparison(obj1, obj2);
 *
 * @param {object} obj1
 * @param {object} obj2
 * @return {boolean}
 */

const comparison = (obj1, obj2) => {
  const keys = Object.keys(obj1);

  for (let i = 0; i < keys.length; i += 1) {
    const val1 = obj1[keys[i]];
    const val2 = obj2[keys[i]];
    if (val1 !== val2) return true;
  }

  return false;
};

/**
 * @description
 * A tool function for warnings to be
 * displayed on the component.
 *
 * @example
 * Namespace.message('A sample message.');
 *
 * @param {any} param
 * @return {Class}
 */

const message = param => (
  <SectionMessage appearance="warning">{param}</SectionMessage>
);

export default {
  comparison,
  message,
};
